export const QUERY_KEY = {
  course: 'COURSE',
  user: 'USER',
};
